import React from 'react';
import VideoCard from '../components/Home/VideoCard';
import { useApp } from '../context/AppContext';

const VideosPage = () => {
    const { videos } = useApp();
    const liveVideos = videos.filter(v => v.status === 'live');

    return (
        <div className="page">
            <div className="section-title">📹 Video News</div>
            <div className="four-col">
                {liveVideos.map(video => (
                    <VideoCard key={video._id} video={video} />
                ))}
            </div>
            {liveVideos.length === 0 && (
                <p style={{ textAlign: 'center', padding: '40px', color: '#888' }}>No videos available</p>
            )}
        </div>
    );
};

export default VideosPage;